<template>
	<AppointmentFormModal v-model:show="visible" @saved="handleSaved()" @deleted="handleSaved()" />
</template>

<script setup lang="ts">
import AppointmentFormModal from "@/components/calendar/AppointmentFormModal.vue"
import { useAppointmentForm } from "@/composables/calendar/useAppointmentForm"
import { emitter } from "@/emitter"

const { visible } = useAppointmentForm()

function handleSaved() {
	// Notify any mounted calendar so it can refresh after a save/delete from anywhere (e.g. search dialog).
	emitter.emit("appointment:saved")
}
</script>
